import { createRouter, createWebHistory } from 'vue-router';
import HomeView from './views/HomeView.vue';
import SignInView from './views/SignInView.vue';
import SignUpView from './views/SignUpView.vue';
import DecksView from './views/DecksView.vue';
import DeckDetailView from './views/DeckDetailView.vue';
import ReviewView from './views/ReviewView.vue';
import IntegrationsView from './views/IntegrationsView.vue';
import SettingsView from './views/SettingsView.vue';
import PrivacyView from './views/PrivacyView.vue';
import HowItWorksView from './views/HowItWorksView.vue';
import OAuthConsentView from './views/OAuthConsentView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/sign-in',
    name: 'sign-in',
    component: SignInView,
  },
  {
    path: '/sign-up',
    name: 'sign-up',
    component: SignUpView,
  },
  {
    path: '/decks',
    name: 'decks',
    component: DecksView,
  },
  {
    path: '/decks/:id',
    name: 'deck-detail',
    component: DeckDetailView,
  },
  {
    path: '/review',
    name: 'review',
    component: ReviewView,
  },
  {
    path: '/integrations',
    name: 'integrations',
    component: IntegrationsView,
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyView,
  },
  {
    path: '/how-it-works',
    name: 'how-it-works',
    component: HowItWorksView,
  },
  {
    path: '/oauth/authorize',
    name: 'oauth-authorize',
    component: OAuthConsentView,
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
